import './Jeopardy.scss';

export default function Jeopardy() {
  return (
    <div className="jeopardy">
        <h1 className="title">Jeopardy</h1>
    </div>
  )
}
